type UserProfile = {
  name?: string | null
  firstName?: string | null
  lastName?: string | null
  title: string | null
  dateOfBirth: string | Date | null
  countryOfBirth: string | null
  country: string | null
  city: string | null
  address: string | null
  postalCode: string | null
  phoneNumber: string | null
  citizenship: string[]
}

export const getUserDisplayName = (user: Pick<UserProfile, "name" | "firstName" | "lastName">) =>
  user.name ?? `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim()

export const hasIncompleteProfile = (user: UserProfile | null | undefined) => {
  if (!user) return false

  const requiredFields = [
    user.title,
    user.dateOfBirth,
    user.countryOfBirth,
    user.country,
    user.city,
    user.address,
    user.postalCode,
    user.phoneNumber
  ]

  const hasEmptyFields = requiredFields.some(field => {
    if (typeof field === 'string') {
      return field.trim() === ''
    }
    return !field
  })
  const hasEmptyCitizenship = !user.citizenship || user.citizenship.length === 0

  return hasEmptyFields || hasEmptyCitizenship
}